import {Injectable} from '@angular/core';
import {BaseResolverService} from '@abstract/base-resolver.service';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {RequestOptions} from '@abstract/api.service';
import {SelectValuesApiService} from '@api/select-values.api.service';

@Injectable()
export class IndustryMethodsSelectValuesListResolver extends BaseResolverService {
    constructor(
        service: SelectValuesApiService,
        router: Router,
    ) {
        super(service, router);
    }

    getRequestParams(snapshot: ActivatedRouteSnapshot): RequestOptions {
        const service = this.resolverService as SelectValuesApiService;
        return {
            url: service.methodsForConclusionList
        };
    }


    processNullData() {
        return [];
    }

    processError() {
        return [];
    }
}
